<template>
  <label :for="id" class="flex items-center cursor-pointer" @click="doClick">
    <!-- label -->
    <div class="text-xs font-normal text-grey-dark mr-2">
      <span>{{ label }} {{ computedState }}</span>
    </div>
    
    <!-- toggle -->
    <div class="relative">
      <!-- input -->
      <input type="checkbox" :id="id" class="sr-only" :checked="state">
      <!-- line -->
      <div class="dot-container block bg-escgrey-midlight w-11 h-6 rounded-full transition duration-300 ease-in-out"></div>
      <!-- dot -->
      <div class="dot absolute left-0.5 top-0.5 bg-white w-5 h-5 rounded-full transition duration-300 ease-in-out"></div>
      <block-spinner :active="toggle" size="5" color="text-blue-light" class="dot-spinner absolute left-0.5 top-0.5 transition duration-300 ease-in-out" :key="id"></block-spinner>
    </div>
  </label>
</template>

<script>
  export default {
    name: 'ToggleBtn',

   	props: {
			id: {
				type: String,
        default: Math.random().toString(36).substr(2, 5) + Date.now()
			},
      state: {
        type: Boolean,

      },
      label: {
        type: String,
        default: 'Toggle'
      }
		},
		
   	data() {
      return {
        toggle: false
      }
    },

    methods: {
      doClick() {
        if(!this.toggle) {
          this.toggle = true;
        }
      }
    },

    computed: {
      computedState() {
        return this.state ? 'on' : 'off';
      },
    },

    watch: {
      state() {
        this.toggle = false;
      }
    }
  };
</script>

<style scoped>
input[type=checkbox]:checked ~ .dot-container {
  @apply bg-blue-light;
}
input[type=checkbox]:checked ~ .dot,
input[type=checkbox]:checked ~ .dot-spinner {
  @apply transform translate-x-full;
}
</style>